import { setUserPermissions } from './set-user-permissions';

/** `PUT /client/:cid/users/:id/permissions {fleet: true}`. */
export const grantFleetAccess = async (user_id: string): Promise<any> =>
  setUserPermissions(user_id, { fleet: true });
